import React from 'react';
import './Home.css';
import Headshot from '../../assets/headshot.jpg';
import Resume from '../../assets/JLeMoure_Resume.pdf';
import HeaderSocials from './HeaderSocials';
import ScrollDown from './ScrollDown';
import Shapes from './Shapes';
import { FaDownload } from 'react-icons/fa';

const Home = () => {
    return (
        <section className="home container" id='home'>
            <div className="intro">
                <img src={Headshot} alt="Joseph LeMoure" className='home__img' width='120' />
                <h1 className="home__name">Joseph LeMoure</h1>
                <span className="home__education">I'm a Software Engineer</span>

                <HeaderSocials />

                <a href={Resume} download className="btn">
                    <FaDownload className="btn__icon" /> Download Resume
                </a>

                <ScrollDown />
            </div>

            <Shapes />
        </section>
    )
}

export default Home